import React from "react";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import "./styles.css";

export default function TickerCell(props) {
  const formattedValue =
    props.value < 10 ? `0${props.value}` : props.value.toString();

  return (
    <Card className="shadow-none tickerCell" style={styles.tickerCell}>
      <CardHeader
        className="balloon"
        title={
          <Typography
            className={`${props.label == "Minutes" || props.label == "Seconds"? "numbers small": "numbers"}`}
            style={styles.tickerCellValue}
          >
            {formattedValue}
          </Typography>
        }
      />
      <CardContent>
        <Typography className="tickerCellLabel" style={styles.tickerCellLabel}>
          {props.label}
        </Typography>
      </CardContent>
    </Card>
  );
}

const styles = {
  tickerCell: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  tickerCellValue: {
    fontSize: "4rem",
  },
  tickerCellLabel: {
    fontStyle: "italic",
  },
  numbers: {
    color: 'dark',
    fontSize: '4em'
  }
};
